import React, { useState } from "react"
import clearButton from "./ClearButton"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import TextField from "@mui/material/TextField"
import Divider from "@mui/material/Divider"

import Tooltip from '@mui/material/Tooltip'

const NsmSearchForm = props => {
  // console.log('NsmSearchForm props:', props)
  const { count, errorMessage, label, searchString } = props
  const [inputValue, setInputValue,] = useState(props.searchString)
  const { submitting, tabIndex } = props
  const disabled = inputValue.length < 5 || inputValue === props.searchString

  const textField = () =>
    <TextField
      style={{ marginTop: 5, marginBottom: 10, backgroundColor: "white" }}
      id="companySearchFormTextField"
      variant="outlined"
      value={inputValue}
      onChange={handleInputChange}
      label={"keyword (5 chars min.)"}
      fullWidth
      InputProps={clearButton({ searchString: inputValue, handleSearchStringClear, tabIndex, textInput: null })}
      onKeyDown={handleKeyDown}
      multiline
      maxRows={4}
    >
    </TextField>

  const searchButton = ({ style }) =>
    <Button
      style={{ height: "auto", color: "white", ...style }}
      className="submitButton"
      variant="contained"
      color="primary"
      size="medium"
      disabled={disabled}
      fullWidth
      type="submit"
    >
      {submitting === "search" ? <CircularProgress size={24} /> : label}
    </Button>

  const message = () => errorMessage === "Bad Gateway"
    ? "Error: please try refining you keyword"
    : `${count} news release${count === 1 ? '' : 's'} found for "${searchString}"`

  const submitButton = () =>
    // @ts-ignore
    <React.Fragment>

      <Tooltip placement="top" title="">
        {searchButton({ style: {} })}
      </Tooltip>

      {searchString !== "" && <h4 style={{ marginBottom: 10, marginTop: 10, textAlign: "left" }}>
        {message()}
      </h4>}

    </React.Fragment>

  const handleInputChange = event => {
    if (event.target.value === "") // If we change the search to "" we need to refresh the page
      handleSearchStringClear()
    else
      setInputValue(event.target.value)
  }

  const handleSubmit = event => {
    event.preventDefault()
    props.news.searchDocument({ searchString: inputValue })
    // console.log('Input value:', inputValue)
  }

  const handleSearchStringClear = event => {
    // console.log('handleSearchStringClear')
    setInputValue("")
    props.news.searchDocument({ searchString: "" })
  }

  const handleKeyDown = event => {
    // console.log('handleKeyDown')
    if (event.which === 13) { // use enter key to submit form
      event.preventDefault()
      handleSubmit(event)
    }
  }

  return (
    <div>
      <form onSubmit={handleSubmit} style={{ paddingRight: 20, marginTop: 10 }}>
        {textField()}
        {submitButton()}
        <Divider style={{ marginTop: 15 }} />
      </form>
    </div>
  )
}

export default NsmSearchForm